<template>

  <div class="feed-content">
    <div class="content">
      
      <div
        v-if="permissions.includes('manage_candidates')"
        class="feed-actions dropdown">
        <button
          class="btn btn-sm btn-light"
          type="button"
          data-toggle="dropdown"
          aria-haspopup="true"
          aria-expanded="false">
          <i class="fas fa-chevron-down" />
          </button>
        <div class="dropdown-menu dropdown-menu-right">
          <button
            class="dropdown-item"
            @click="deleteMeetinsight(meetinsight._id)">
            <i class="fas fa-times" /> {{ $t('Remove') }}
            </button>
        </div>
      </div>

      <div class="author">
        <div><span class="text-muted">{{ $t('Start Date') }}:</span> {{ $d(new Date(meetinsight.start_date), 'long') }}</div>
        <div><span class="text-muted">{{ $t('Duration') }}:</span> {{ meetinsight.duration_time }}</div>
        <div><span class="text-muted">{{ $t('Participants') }}:</span> {{ meetinsight.max_participants }}</div>
      </div>
      <div class="my-3" style="white-space: pre-wrap;">{{ meetinsight.analysis }}</div>

      <ul
        v-if="meetinsight.key_points && meetinsight.key_points.length"
        class="list-group">
        <li
          class="list-group-item"
          v-for="(item, index) in meetinsight.key_points"
          :key="index">
          {{ item }}
        </li>
      </ul>

      <div v-if="showAll">
        <hr class="my-4" />
        <div class="text-muted mb-2">
          <p><i>A transcrição é gerada automaticamente por inteligência artificial a partir do áudio da reunião. Em alguns momentos, principalmente no início ou quando a qualidade do som está baixa (com ruídos, falas sobrepostas ou microfones distantes), a transcrição pode exibir caracteres estranhos ou frases confusas.</i></p>
          <p><i>Isso é esperado e, normalmente, a IA ajusta o padrão de reconhecimento conforme a conversa avança.</i></p>
          <p><i>Além disso, a inteligência artificial que analisa as transcrições já está preparada para lidar com esses ruídos e imprecisões pontuais.</i></p>
        </div>
        <table>
          <tbody>
            <tr
              v-for="(cue, index) in transcriptionCues"
              :key="index">
              <td width="90" class="text-muted">{{ cue.start }} - {{ cue.end }}</td>
              <td width="10"></td>
              <td v-html="cue.text.replace('</v>', '</v> ')"></td>
            </tr>
          </tbody>
        </table>
      </div>
      <a
        href="javascript:void(0)"
        @click="showAll=!showAll">
        {{ showAll ? $t('Hide translation') : $t('Show translation') }}
        </a>
    </div>
  </div>

</template>

<script>
import config from '@/config'
import Avatar from '@/components/Parts/Avatar'
import moment from 'moment'

export default {
  name: 'CandidateQualificationItem',
  components: {
    Avatar
  },
  props: {
    activity: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      showAll: false
    }
  },
  computed: {
    permissions () {
      return this.$store.getters.getPermissions
    },
    imgSrc () {
      const defaultImageUrl = config.default_image_url.candidate
      const url = this.activity.author_user.photo_media_url
      return url && !url.includes(defaultImageUrl) ? url : null
    },
    meetinsight () {
      return this.activity.meetinsight || {}
    },
    transcriptionCues () {
      const rows = this.meetinsight.transcription_cues || []
      return rows.map((cue) => {
        return {
          start: moment().startOf('day').set({ second: cue.start }).format('mm:ss'),
          end: moment().startOf('day').set({ second: cue.start }).format('mm:ss'),
          text: cue.text
        }
      })
    }
  },
  created () {
  },
  methods: {
    deleteMeetinsight (id) {
      const deleteAction = () => {
        this.loading = true

        this.$store
        .dispatch('deleteMeetinsight', id)
        .then((result) => {
          return this.$store
          .dispatch('deleteActivity', this.activity._id)
        })
        .then((result) => {
          this.loading = false
          this.$emit('deleted', result)
        })
      }

      this.$store
      .dispatch('setAlertModal', {
        action: deleteAction
      })
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Candidate/Feed/CandidateFeedMeetinsightItem.vue